import {FC} from 'react'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'

const ProjectCardSkeleton: FC = () => {
  return (
    <div className='col-xl-4 col-lg-6 col-md-6'>
      <KTCard className='card-xl-stretch mb-xl-8 h-100'>
        <KTCardBody className='d-flex flex-column p-6'>
          {/* Header Skeleton */}
          <div className='d-flex align-items-center justify-content-between mb-4'>
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-50px me-3'>
                <div className='symbol-label bg-light-primary placeholder-wave'></div>
              </div>
              <div>
                <div className='placeholder placeholder-lg bg-light w-150px mb-2'></div>
                <div className='placeholder placeholder-sm bg-light w-100px'></div>
              </div>
            </div>
            <div className='btn-group'>
              <div className='placeholder placeholder-lg bg-light w-30px h-30px rounded'></div>
            </div>
          </div>

          {/* Description Skeleton */}
          <div className='mb-4 flex-grow-1'>
            <div className='placeholder placeholder-lg bg-light w-100 mb-2'></div>
            <div className='placeholder placeholder-lg bg-light w-100 mb-2'></div>
            <div className='placeholder placeholder-lg bg-light w-75'></div>
          </div>

          {/* Tags Skeleton */}
          <div className='mb-4'>
            <div className='d-flex gap-2 mb-2'>
              <div className='placeholder placeholder-lg bg-light w-60px h-25px rounded'></div>
              <div className='placeholder placeholder-lg bg-light w-70px h-25px rounded'></div>
              <div className='placeholder placeholder-lg bg-light w-80px h-25px rounded'></div>
            </div>
          </div>

          {/* Stats Skeleton */}
          <div className='row mb-4'>
            <div className='col-6'>
              <div className='d-flex align-items-center'>
                <div className='placeholder placeholder-lg bg-light w-24px h-24px rounded me-2'></div>
                <div>
                  <div className='placeholder placeholder-lg bg-light w-30px mb-1'></div>
                  <div className='placeholder placeholder-sm bg-light w-50px'></div>
                </div>
              </div>
            </div>
            <div className='col-6'>
              <div className='d-flex align-items-center'>
                <div className='placeholder placeholder-lg bg-light w-24px h-24px rounded me-2'></div>
                <div>
                  <div className='placeholder placeholder-lg bg-light w-30px mb-1'></div>
                  <div className='placeholder placeholder-sm bg-light w-50px'></div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Skeleton */}
          <div className='d-flex align-items-center justify-content-between'>
            <div className='placeholder placeholder-lg bg-light w-60px h-25px rounded'></div>
            <div className='placeholder placeholder-lg bg-light w-100px h-35px rounded'></div>
          </div>
        </KTCardBody>
      </KTCard>
    </div>
  )
}

export {ProjectCardSkeleton}

